<template>
  <div class="StudentHome mb-5" xs12>

    <!--<v-toolbar flat fixed class="toolbar cont text-xs-center" app dark xs12>-->
      <!--<div xs6 class="btn-tool text-xs-right">-->
        <!--<router-link to="/student#chat" class="aBtn">-->
          <!--<v-icon class="textColor pt-2">fas fa-arrow-left</v-icon>-->
        <!--</router-link>-->
      <!--</div>-->
      <!--<v-spacer></v-spacer>-->
      <!--<v-toolbar-title>-->
        <!--<h2 class=" text-xs-center font-weight-bold title pb-1">{{selectedUser.name}}<h6 color="black">{{selectedUser.lastSeenAgo}}</h6></h2>-->
        <!--&lt;!&ndash; <div class=" text-grey f-12 text-xs-center">today</div> &ndash;&gt;-->
      <!--</v-toolbar-title>-->
      <!--<v-spacer></v-spacer>-->
      <!--<v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>-->
    <!--</v-toolbar>-->

    <v-container fluid grid-list-xl class=" mt-0 mb-4 ">
      <v-layout row wrap class="mb-2">
        <!--<h2>Chat Messages</h2>-->
        <!-- ​<v-flex v-for="chat in messages">
            <div class="coniner darker card-r mb-2 w-100 pa-2"  >
              <img src="https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg" alt="Avatar" class="right" style="width:100%;">
              <p class="text-xs-left pa-2 f-15 font-weight-medium text-grey mr-50 ">{{chat.msg}}</p>
              <span class="time-left pl-2">{{chat.time}}</span>
            </div>
            ​
            <div class="coniner primary card-r mb-2 w-100 pa-2" >
              <img src="https://adayinthelifeimages.com/wp-content/uploads/2016/05/brisbane-headshots-commercial-photography-09.jpg" alt="Avatar" style="width:100%;">
              <p class="text-xs-right text-white pa-2 f-15 ml-50">Hello ! Good morning, jesper</p>
              <span class="time-right text-white pr-2">11:04</span>
            </div>
        </v-flex> -->
      <div class="w-100 text-xs-center">
        <v-flex xs12 lg12>
          <router-link to="/ChatList"><v-icon class="textColor left">keyboard_arrow_left</v-icon></router-link>
          <h1 class="f-20 mb-2 font-weight-bold">Create Event</h1>
        </v-flex>
      </div>
        <v-flex xs12 v-for="chat in messages" id="chatWindow" class="pa-0 ">

          <v-card class="no-shadow card-r transparent" v-if="chat.type=='send'">
            <v-container fluid grid-list-xl class="pt-0">
              <v-layout row wrap class="">
                <v-flex xs10>
                  <v-card class="no-shadow darker chat-r-l" primary-title>
                    <div class="text-xs-left">
                      <p class="text-xs-right pa-3 f-15 font-weight-medium text-grey">{{chat.message}}</p>
                    </div>
                    <div class="text-xs-left">
                      <p class="text-xs-left pl-3 pb-3 f-10 font-weight-medium text-grey">{{ (chat.created_at).substring(10,19) }}</p>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs2 class="pa-0 text-xs-center">
                  <v-avatar class="ma-2"
                            :size="40"
                            color="grey lighten-4">
                    <img class="grey-out-line"
                         style="object-fit: cover!important;"
                         :src="profileImage" alt="avatar">
                  </v-avatar>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card class="no-shadow card-r transparent" v-if="chat.type=='receive'">
            <v-container fluid grid-list-xl class="pt-0">
              <v-layout row wrap class="">
                <v-flex xs2 class="pa-0 text-xs-center">
                  <v-avatar class="ma-2"
                            :size="40"
                            color="grey lighten-4">
                    <img class="primary-out-line"
                         style="object-fit: cover!important;"
                         :src="messages[0].base_url+'/'+messages[0].receiver.image" alt="avatar">
                  </v-avatar>
                </v-flex>
                <v-flex xs10>
                  <v-card class="no-shadow primary chat-r-r" primary-title>
                    <div class="text-xs-left">
                      <p class="text-xs-left pa-3 f-15 font-weight-medium text-white">{{chat.message}}</p>
                    </div>
                    <div class="text-xs-left">
                      <p class="text-xs-right pr-3 pb-3 f-10 font-weight-medium text-white">{{ (chat.created_at).substring(10,19) }}</p>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <!-- ​<v-flex class="pa-0 ma-0 w-100">
            <div class="coniner darker card-r mb-2 w-100 pa-2 pb-4" >
              <img src="https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg" alt="Avatar" class="right" style="width:100%;">
              <p class="text-xs-left pa-2 f-15 font-weight-medium text-grey mr-50">{dfdf</p>
              <span class="time-left pl-2">11.02</span>
            </div>
            ​
            <div class="coniner primary card-r mb-2 w-100 pa-2 pb-4">
              <img src="https://adayinthelifeimages.com/wp-content/uploads/2016/05/brisbane-headshots-commercial-photography-09.jpg" alt="Avatar" style="width:100%;">
              <p class="text-xs-right text-white pa-2 f-15 ml-50">Hello ! Gofgfgfgfdgfdgfdgfdgsfdjhdnuhufhdfhudfhod morning, jesper</p>
              <span class="time-right text-white pr-2">11:04</span>
            </div>
        ​</v-flex> -->

        ​





        <!--<v-flex xs10   offset-sm3 class="pr-0 pa-0">-->
        <!--<v-card class="no-shadow card-r ">-->
        <!--<v-list three-line>-->
        <!--<v-list-tile-->
        <!--v-for="item in items"-->
        <!--:key="item.title"-->
        <!--avatar-->
        <!--@click=""-->
        <!--&gt;-->
        <!--<v-list-tile-content class="grey lighten-3 f-15 card-r no-shadow pa-2 f-15 font-weight-medium text-grey">-->
        <!--<v-list-tile-sub-title class="f-12">Jesper</v-list-tile-sub-title>-->
        <!--<p>Hi..Good Morning!</p>-->
        <!--</v-list-tile-content>-->
        <!--</v-list-tile>-->
        <!--</v-list>-->

        <!--</v-card>-->
        <!--</v-flex>-->
        <!--<v-flex xs2   offset-sm3 class="pa-0 ">-->
        <!--<v-avatar-->
        <!--:tile="tile"-->
        <!--:size="45"-->
        <!--color="grey lighten-4">-->
        <!--<img class="br-3"-->
        <!--style="object-fit: cover!important;"-->
        <!--src="https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg" alt="avatar">-->
        <!--</v-avatar>-->

        <!--</v-flex>-->

        <!--<v-flex xs2   offset-sm3 class="pa-0 ">-->
        <!--<v-avatar-->
        <!--:tile="tile"-->
        <!--:size="45"-->
        <!--color="grey lighten-4">-->
        <!--<img class="br-3"-->
        <!--style="object-fit: cover!important;"-->
        <!--src="https://cdn.vuetifyjs.com/images/lists/1.jpg" alt="avatar">-->
        <!--</v-avatar>-->

        <!--</v-flex>-->
        <!--<v-flex xs10   offset-sm3 class="pr-0 pa-0">-->
        <!--<v-card class="no-shadow card-r red ">-->
        <!--<v-list three-line>-->
        <!--<v-list-tile-->
        <!--v-for="item in items"-->
        <!--:key="item.title"-->
        <!--avatar-->
        <!--@click=""-->
        <!--&gt;-->
        <!--<v-list-tile-content class="grey lighten-3 f-15 card-r no-shadow pa-2 f-15 font-weight-medium text-grey">-->
        <!--<v-list-tile-sub-title class="f-12">Adam</v-list-tile-sub-title>-->
        <!--<p>Hello ! Good morning</p>-->
        <!--</v-list-tile-content>-->
        <!--</v-list-tile>-->
        <!--</v-list>-->

        <!--</v-card>-->
        <!--</v-flex>-->

        <!--<v-flex xs10   offset-sm3 class="pr-0 pa-0">-->
        <!--<v-card class="no-shadow card-r ">-->
        <!--<v-list three-line>-->
        <!--<v-list-tile-->
        <!--v-for="item in items"-->
        <!--:key="item.title"-->
        <!--avatar-->
        <!--@click=""-->
        <!--&gt;-->
        <!--<v-list-tile-content class="grey lighten-3 f-15 card-r no-shadow pa-2 f-15 font-weight-medium text-grey">-->
        <!--<v-list-tile-sub-title class="f-12 ">Jesper</v-list-tile-sub-title>-->
        <!--<p>May i know when can i finish all of my classes to get license? Would i take some extra-->
        <!--lessons to learn quickly since I need to get the license soon.</p>-->
        <!--</v-list-tile-content>-->
        <!--</v-list-tile>-->
        <!--</v-list>-->

        <!--</v-card>-->
        <!--</v-flex>-->
        <!--<v-flex xs2   offset-sm3 class="pa-0 ">-->
        <!--<v-avatar-->
        <!--:tile="tile"-->
        <!--:size="45"-->
        <!--color="grey lighten-4">-->
        <!--<img class="br-3"-->
        <!--style="object-fit: cover!important;"-->
        <!--src="https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg" alt="avatar">-->
        <!--</v-avatar>-->

        <!--</v-flex>-->

        <!--<v-flex xs2   offset-sm3 class="pa-0 ">-->
        <!--<v-avatar-->
        <!--:tile="tile"-->
        <!--:size="45"-->
        <!--color="grey lighten-4">-->
        <!--<img class="br-3"-->
        <!--style="object-fit: cover!important;"-->
        <!--src="https://cdn.vuetifyjs.com/images/lists/1.jpg" alt="avatar">-->
        <!--</v-avatar>-->

        <!--</v-flex>-->
        <!--<v-flex xs10   offset-sm3 class="pr-0 pa-0">-->
        <!--<v-card class="no-shadow card-r ">-->
        <!--<v-list three-line>-->
        <!--<v-list-tile-->
        <!--v-for="item in items"-->
        <!--:key="item.title"-->
        <!--avatar-->
        <!--@click=""-->
        <!--&gt;-->
        <!--<v-list-tile-content class="grey lighten-3 f-15 card-r no-shadow pa-2 f-15 font-weight-medium text-grey">-->
        <!--<v-list-tile-sub-title class="f-12">Adam</v-list-tile-sub-title>-->
        <!--<p>Yes Jesper,I can arrange for some special classes for you once-->
        <!--you finished all of the package classes then, I will talk with manager and tell you.</p>-->
        <!--</v-list-tile-content>-->
        <!--</v-list-tile>-->
        <!--</v-list>-->

        <!--</v-card>-->
        <!--</v-flex>-->

        <!--<v-flex xs10   offset-sm3 class="pr-0 pa-0">-->
        <!--<v-card class="no-shadow card-r ">-->
        <!--<v-list three-line>-->
        <!--<v-list-tile-->
        <!--v-for="item in items"-->
        <!--:key="item.title"-->
        <!--avatar-->
        <!--@click=""-->
        <!--&gt;-->
        <!--<v-list-tile-content class="grey lighten-3 f-15 card-r no-shadow pa-2 f-15 font-weight-medium text-grey">-->
        <!--<v-list-tile-sub-title class="f-12">Jesper</v-list-tile-sub-title>-->
        <!--<p>Okay, Thank you Adam</p>-->
        <!--</v-list-tile-content>-->
        <!--</v-list-tile>-->
        <!--</v-list>-->

        <!--</v-card>-->
        <!--</v-flex>-->
        <!--<v-flex xs2   offset-sm3 class="pa-0 ">-->
        <!--<v-avatar-->
        <!--:tile="tile"-->
        <!--:size="45"-->
        <!--color="grey lighten-4">-->
        <!--<img class="br-3"-->
        <!--style="object-fit: cover!important;"-->
        <!--src="https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg" alt="avatar">-->
        <!--</v-avatar>-->

        <!--</v-flex>-->
      </v-layout>
    </v-container>
    <div>
      <v-form>
        <v-container class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 sm8 class="w-100 pa-2 chat-box-fiwex f-15 font-weight-medium text-grey">
              <v-text-field
                v-model="message"
                solo
                placeholder="Text message..."
                :append-outer-icon="message ? 'send' : ''"
                type="text"
                class="pa-0 ma-0"
                required
                @click:append-outer="sendMessage"
              ></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>
    </div>
  </div>
</template>


<script>
  /* eslint-disable */

  import api from "@/utils/backend-api"
  import Pusher from 'pusher-js'
  import { mapState } from 'vuex'

  export default {
    props: ['id','type'],
    data: () => ({
      password: 'Password',
      show: false,
      message: '',
      marker: true,
      iconIndex: 0,
      icons: [
        'mdi-emoticon',
        'mdi-emoticon-cool',
        'mdi-emoticon-dead',
        'mdi-emoticon-excited',
        'mdi-emoticon-happy',
        'mdi-emoticon-neutral',
        'mdi-emoticon-sad',
        'mdi-emoticon-tongue'
      ],
      items: [],
      profileImage:'',
      receiverImage:'',
      selectedUser:{
        name:'',
        lastSeenAgo:''
      },
      messages:[],
      channel:null,
      pusher:null,
      scrolledToBottom:false
    }),
    created:function(){
      console.log(this.id)
      this.GetChats(this.id,this.type)

      this.profileImage=this.user.image
      let id=this.id
      // chatList=Store.chatList
      this.chatList.chat.forEach((element,index)=>{
        if(element.opposite_id==id){
          // this.selectedUser=element
          if(element.sender){
            this.selectedUser.name=element.sender.name
            this.selectedUser.lastSeenAgo=element.sender.lastSeenAgo
          }else if(element.receiver){
            this.selectedUser.name=element.receiver.name
            this.selectedUser.lastSeenAgo=element.receiver.lastSeenAgo
          }
        }
      })
      this.chatList.contact.forEach((element,index)=>{
        if(element.id==id){
          // this.selectedUser=element
          this.selectedUser.name=element.name
          this.selectedUser.lastSeenAgo=element.lastSeenAgo
        }
      })

      // let alreadyHave=this.setMessages(id)

      // if(!alreadyHave){
      api.postData('student/view_message',{user_id:id})
        .then(res=>{
          let response=res.data
          let data={
            chatId:id,
            messages:res.data
          }
          // console.log('id',id)
          this.$store.dispatch('setChatMessages',{data})
          // setTimeout(()=>{
          // console.log(id)
          this.setMessages(id)
          // },2000);
        }).catch(err=>{

      })
      // }else{
      //   console.log("already have")
      // }

    },
    mounted:function(){
      var el = document.getElementById('#chatWindow')
      // console.log(el)
      // el.scrollTop = el.scrollHeight

      this.pusher=new Pusher('e9455c16bc5f0d6c4547',{
        cluster: 'ap2',
        encrypted: true,
        disableStats: true,
      })
      let pusherToken=Store.state.pusherToken
      this.channel=this.pusher.subscribe(pusherToken);
      this.channel.bind('sendMessagesToUser', function(message) {
        Store.state.chatMessages[0].messages.push(message)
        // console.log(message);
      });
      // console.log(this.pusher)
      // console.log(this.channel)
      window.scrollTo(0, 100000)
    },
    updated:function() {
      //  var el = document.getElementById('#chatWindow')
      //  el.scrollTop = el.scrollHeight
    },
    computed: {
      ...mapState([
        'loadedDataStatus',
        'packageList',
        "chatList",
        "chatMessages",
        'user'
      ]),

      icon () {
        return this.icons[this.iconIndex]
      }
    },
    methods: {
      GetChats(type,item){
        // debugger
        if(type=='chat'){
          if(item.type=='send'){
            // this.selectedUserName=item.receiver.name
            // this.selectedUserlastSeenAgo=item.receiver.lastSeenAgo
            this.selectedUserId=item.receiver_id
          }else if(item.type='receive'){
            // this.selectedUserName=item.sender.name
            // this.selectedUserlastSeenAgo=item.sender.lastSeenAgo
            this.selectedUserId=item.sender_id
          }

        }else if(type=='contact'){
          // this.selectedUserName=item.name
          // this.selectedUserlastSeenAgo=item.lastSeenAgo
          this.selectedUserId=item.id
        }

        // this.selectedUserName=name
        // this.selectedUserlastSeenAgo=lastSeenAgo
        // this.selectedUserId=id
        let self=this
        api.postData('admin/viewMessage',{user_id:this.id})
        .then(res=>{
          if(res.status==200){
              this.selectedUserMessages=res.data
              // let messages=res.data
              // debugger
              let data={
                id:self.selectedUserId,
                messages:res.data
              }
              Store.dispatch('setChatMessages',{data})

              this.selecteduserImage=res.data[0].base_url+'/'+res.data[0].sender.image
          }else{
              this.selectedUserMessages=[]
              Store.dispatch('setEmptyChatMessages')
          }
        }).catch(err=>{
          Store.dispatch('setChatMessages',[])
          this.selectedUserMessages=[]
        })
      },
      scroll () {
        window.onscroll = () => {
          let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

          if (bottomOfWindow) {
            this.scrolledToBottom = true // replace it with your code
          }
        }
      },
      setMessages(chatId){
        // console.log(chatId)
        let status
        if(this.chatMessages.length>0){
          this.chatMessages.forEach((element,index)=>{
            // console.log(chatId)
            // console.log(element.id)
            if(element.id==chatId){
              this.messages=element.messages
              status=true
            }else{
              status=false
            }
          })
          return status
        }else{
          return false
        }

      },
      toggleMarker () {
        this.marker = !this.marker
      },
      sendMessage () {
        // console.log("sent")
        // this.resetIcon()
        // let message=
        let msg={
          message:this.message,
          created_at:"06.12",
          type:'send'
        }
        let TeacherId=this.id

        api.postData('student/message',{user_id:TeacherId,message:this.message})
          .then(res=>{
            if(res.status==201){
              this.messages.push(msg)

              this.clearMessage()
              SaveDataToLocalStorage(data)
              // setTimeout(()=>{
              // window.scrollTo(0,document.body.scrollHeight);
              // var container = this.$el.querySelector("#container")
              // container.scrollTop = container.scrollHeight
              // },1000);
            }
          }).catch(err=>{

        })
        // console.log(this.messages)
      },
      clearMessage () {
        this.message = ''
      },
      resetIcon () {
        this.iconIndex = 0
      },
      changeIcon () {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      }
    }
  }
</script>
<style>
  .chat-r-r{
    border-radius: 0px 10px 10px 40px !important;
  }
  .chat-r-l{
    border-radius: 10px 0px 40px 15px !important;
  }
  .primary-out-line{
    border: 2px solid #0051a0;
  }
  .grey-out-line{
    border: 2px solid #424242;
  }
  .text-grey{
    color: darkslategray!important;
  }
  .float-right{
    float: right!important;
  }
  .float-left{
    float: left!important;
  }
  .w-50{
    width: 75% !important;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .darker {
    border-color: #ccc;
    background-color: #ddd !important;
  }

  .container::after {
    content: "";
    clear: both;
    display: table;
  }

  .coniner img {
    float: left;
    max-width: 40px;
    height: 40px;
    object-fit: cover;
    width: 100%;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: -5px;
    border-radius: 50%;
  }

  .container img.right {
    float: right;
    margin-left: 10px;
    margin-right: 10px;
  }

  .time-right {
    float: right;
    color: #aaa;
  }
  .mr-50{
    margin-right: 50px!important;
  }
  .ml-50{
    margin-left: 50px!important;
  }
  .time-left {
    float: left;
    color: #999;
  }
  .coniner{
    margin-top: 10px;
  }
  /*.v-text-field.v-text-field--enclosed .v-input__prepend-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer {*/
  /*margin-top: 26px!important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/chat/Chats.vue